const STORAGE_KEY = "sidebarCollapsedOverride";
const EVENT_NAME = "sidebarCollapseChange";

export const getSidebarCollapseOverride = () => {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (raw === "1") return true;
  if (raw === "0") return false;
  return null;
};

export const setSidebarCollapseOverride = (value) => {
  if (value === null || value === undefined) {
    sessionStorage.removeItem(STORAGE_KEY);
  } else {
    sessionStorage.setItem(STORAGE_KEY, value ? "1" : "0");
  }
  window.dispatchEvent(new CustomEvent(EVENT_NAME));
  setTimeout(() => window.dispatchEvent(new Event("resize")), 50);
};

export const toggleSidebarCollapseOverride = (defaultCollapsed = false) => {
  const current = getSidebarCollapseOverride();
  const effective = current === null ? defaultCollapsed : current;
  setSidebarCollapseOverride(!effective);
};

export const subscribeSidebarCollapse = (cb) => {
  const handler = () => cb();
  window.addEventListener(EVENT_NAME, handler);
  return () => window.removeEventListener(EVENT_NAME, handler);
};

// Which routes honour the chart's Full Screen toggle.
//
// The full-screen button collapses the app sidebar (and hides the dashboard
// header) to hand the chart the whole viewport. Every consumer of that state —
// Sidebar, SidebarToggleArrow, PageContainer, char.jsx, ChartRightWatchlist,
// Chart.js — used to carry its own copy of this test, and every copy read:
//
//     pathname.endsWith("/charts") || pathname.startsWith("/chartSearch/")
//
// The League Trade screen is `/<slug>/trade`, which matches neither. So on that
// screen the override was written to sessionStorage and then ignored by all six
// readers: the icon toggled, nothing moved. That is the client's Slack note —
// "the full-screen icon not functioning inside a league trade screen".
//
// One predicate now, so the six cannot drift apart again. `/<slug>/trade` is
// matched exactly (a single leading segment, nothing after "trade"), which is
// the League Trade screen and nothing else — `/<slug>/charts` already matched
// via the endsWith test and is unaffected.
export const isFullScreenChartRoute = (pathname = "") =>
  pathname.endsWith("/charts") ||
  pathname.startsWith("/chartSearch/") ||
  /^\/[^/]+\/trade$/.test(pathname);
